import Vue from 'vue'
import EosUtils from '../utils/EosUtils'
import TextUtils from '../utils/TextUtils';

Vue.mixin({
    data: function () {
        return {
            baseUrl: process.env.VUE_APP_VAPID_PUBLIC_KEY,
        }
    },
    methods: {
        loadTheme() {
            const activeTheme = localStorage.getItem("user-theme");
            if (activeTheme === "dark-theme") {
                this.setTheme("dark-theme");
            } else {
                this.setTheme("light-theme");
            }
        },
        setTheme(theme) {
            localStorage.setItem("user-theme", theme);
            document.documentElement.className = theme;
            if (theme === "dark-theme") {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        },
        toggleTheme() {
            const activeTheme = localStorage.getItem("user-theme");
            if (activeTheme === "light-theme") {
                this.setTheme("dark-theme");
            } else {
                this.setTheme("light-theme");
            }
        },
        isDarkTheme() {
            const activeTheme = localStorage.getItem("user-theme");
            if (activeTheme === "dark-theme") {
                return true
            } else {
                return false
            }
        },
        ConvertMinuteToHour(min) {
            return EosUtils.ConvertMinToHour(min);
        },
        ConvertToEnglishDigits(str) {
            return TextUtils.convertToEnglishDigits(str);
        },
        setUserTheme(colorNumber) {
            ////debugger;
            let dark={};
            let light={};
            if(colorNumber=="2"){
                // this.clearTheme()
                this.$vuetify.theme.themes.name ="قالب نارنجی";
                this.$vuetify.theme.themes.colorNumber = colorNumber;
                 dark={
                    primary: "#E65100",
                    accent: "#fcc401",
                    secondary: "#689F38",
                    success: "#4CAF50",
                    info: "#6156d8",
                    warning: "#1565C0",
                     error: "#FF7043",
                }
                 light={
                    primary: "#E65100",
                    accent: "#fcc401",
                    secondary: "#92de4e",
                    success: "#6dff74",
                    info: "#7365ff",
                    warning: "#2e8ac0",
                    error: "#ff5e3c",
                }
                this.$vuetify.theme.themes.dark=dark;
                this.$vuetify.theme.themes.light=light;

            }
            else if(colorNumber=="3"){
                // this.clearTheme()
                this.$vuetify.theme.themes.name ="قالب سبز";
                this.$vuetify.theme.themes.colorNumber = colorNumber;
                 dark={
                    primary: "#689F38",
                    accent: "#7CB342",
                    secondary: "#689F38",
                    success: "#4CAF50",
                    info: "#f34fc6",
                    warning: "#FB8C00",
                    error: "#ffb4b4",
                    textcolor:"#ffffff",
                }
                 light={
                    primary: "#689F38",
                    accent: "#a1e754",
                    secondary: "#26ff8c",
                    success: "#9cf4dc",
                    info: "#ff53d0",
                    warning: "#ff8e00",
                    error: "#ffb4b4",
                    textcolor:"#000000",
                }
                this.$vuetify.theme.themes.dark=dark;
                this.$vuetify.theme.themes.light=light;
            }
            else if(colorNumber=="4"){
                // this.clearTheme()
                this.$vuetify.theme.themes.name ="قالب آبی";
                this.$vuetify.theme.themes.colorNumber = colorNumber;
                 dark={
                    primary: "#2380ad",
                    accent: "#7CB342",
                    secondary: "#689F38",
                    success: "#4CAF50",
                    info: "#f34fc6",
                    warning: "#FB8C00",
                    error: "#ffb4b4",
                    textcolor:"#ffffff",
                }
                 light={
                    primary: "#2380ad",
                    accent: "#a1e754",
                    secondary: "#26ff8c",
                    success: "#9cf4dc",
                    info: "#ff53d0",
                    warning: "#ff8e00",
                    error: "#ffb4b4",
                    textcolor:"#000000",
                }
                this.$vuetify.theme.themes.dark=dark;
                this.$vuetify.theme.themes.light=light;
            }else {
                this.$vuetify.theme.themes.name ="قالب اصلی";
                this.$vuetify.theme.themes.colorNumber = "1";
                light= {
                    primary: "#272161",
                    accent: "#fcc401",
                    secondary: "#21dc79",
                    success: "#9cf4dc",
                    info: "#f34fc6",
                    warning: "#FB8C00",
                    error: "#ffb4b4",
                  },
                  dark= {
                    primary: "#646172",
                    accent: "#fcc401",
                    secondary: "#26ff8c",
                    success: "#9cf4dc",
                    info: "#ff53d0",
                    warning: "#ff8e00",
                    error: "#ffb4b4",
                },
                
                this.$vuetify.theme.themes.dark=dark;
                this.$vuetify.theme.themes.light=light;
            }

        },
        clearThebe(){
            ////debugger
            this.$vuetify.theme.themes.name ="";
            this.$vuetify.theme.themes.colorNumber = "";
            this.$vuetify.theme.themes.dark={};
            this.$vuetify.theme.themes.light={};
        },
    },
})